import { useQuery } from "@tanstack/react-query";
import { useCheckout } from "../contexts/CheckoutPageContext";
import { usePageSettings } from "../contexts/PageSettingsContext";
import { useSelectedPlanContext } from "../contexts/SelectedPlanContext";

export const useFetchTotalPrice = ({ addonIds = [], paymentCycle = "monthly" }) => {
	const { selectedLocation, currency } = usePageSettings();
	const { selectedPlan } = useSelectedPlanContext();
	const { orderCount } = useCheckout();
	const selectedService = selectedPlan.service;

	// Extract only IDs from addons

	const fetchPrice = async () => {
		let payloadData = {};

		// Populate resources based on the selected service
		switch (selectedService) {
			case "colocation":
				payloadData.resources = [
					{
						location_code: selectedLocation.iata_code,
						service: "colocation",
						id_rack: selectedPlan.rack?.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: "colocation",
						id_prefix: selectedPlan.prefix?.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: "colocation",
						id_energy: selectedPlan.energy?.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: "colocation",
						id_bandwidth: selectedPlan.bandwidth?.id,
					},
				];
				payloadData.addons = addonIds || [];
				break;

			case "vps":
			case "baremetal":
				payloadData.resources = [
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_cpu: selectedPlan.cpu?.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_storage: selectedPlan.storage?.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_ram: selectedPlan.ram?.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_transfer: selectedPlan.transfer?.id,
					},
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_bandwidth: selectedPlan.bandwidth?.id,
					},
				];
				payloadData.addons = addonIds || [];
				break;

			case "storage":
				payloadData.resources = [
					{
						location_code: selectedLocation.iata_code,
						service: selectedService,
						id_nas: selectedPlan.nas?.id,
					},
				];
				break;

			case "ultraproxy":
				payloadData = {
					ultraproxies: [selectedLocation.iata_code],
				};
				break;
			case "bgp":
				payloadData = {
					bgps: [selectedLocation.iata_code],
				};
				break;
			case "iptransit":
				payloadData.resources = [
					{
						location_code: selectedLocation.iata_code,
						service: "iptransit",
						id_bandwidth: selectedPlan.bandwidth?.id,
					},
				];

				break;
			case "webhosting":
				payloadData.plans = [selectedPlan?.id];
				break;

			default:
				console.warn(`Unsupported service type: ${selectedService}`);
				break;
		}

		const endpoint = `${process.env.GATSBY_ADDON_PRICES_ENDPOINT}?currency=${currency}&cycle=${paymentCycle}&count=${orderCount}`;
		try {
			const response = await fetch(endpoint, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(payloadData),
			});
			if (response.ok) {
				const priceData = await response.json();
				return priceData.price;
			} else {
				console.error("Error fetching price:", response.error);
				return 0;
			}
		} catch (error) {
			console.error("Error fetching price:", error);
			return 0;
		}
	};

	return useQuery({
		queryKey: [
			"totalPrice",
			currency,
			selectedPlan.id,
			selectedLocation?.iata_code,
			addonIds,
			paymentCycle,
			orderCount,
		],
		queryFn: fetchPrice,
		refetchOnWindowFocus: false,
		enabled: true,
	});
};
